<template>
  <div>
    <b-modal
      ok-title="Salvar"
      id="modal-default-template"
      title="Criar painel pré-definido"
      centered
      v-b-toggle.sidebar-right
      size="lg"
      v-model="modalPanel"
    >
      <div style="text-align: center;">
        <button class="ball-create-panel">1</button>
        <span>Escolha o tipo do painel</span>

        <button class="ball-create-panel">2</button>
        <span>Configuração do painel</span>
      </div>

      <div>
        <p class="text-create-panel">Título do painel</p>
        <input v-model="title" class="form-control" />

        <p class="text-create-panel">Descrição</p>
        <textarea v-model="description" class="form-control" />

        <template v-if="userProfile.permissions.panels.share_panel">
          <p class="text-create-panel">Perfis que terão acesso</p>
          <b-form-checkbox-group
            v-model="perfils"
            :options="profiles"
            class="mb-3"
          ></b-form-checkbox-group>
        </template>
      </div>

      <template #modal-footer>
        <b-button variant="outline-primary" @click="cancel">
          Cancelar
        </b-button>
        <b-button variant="primary" @click="savePanel()">Salvar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import imgUseTemplate from '../../../assets/use-template.jpg';
import imgMakePanel from '../../../assets/make-panel.jpg';
// import api from '../../../services/api';

export default {
  name: 'ModalAddPanelDefault',

  data: () => ({
    disabledCustom: true,
    disabledDefault: true,
    modalPanel: null,
    showSidebar: null,
    imgUseTemplate,
    imgMakePanel,
    selectedReport: null,
    selectedMetric: null,
    selectedPeriod: null,
    slide: 0,
    sliding: null,
    title: null,
    description: null,
    perfils: [],
    userAuth: null,
  }),

  computed: {
    ...mapState('panels', ['panelsInfo']),
    ...mapFields('panels', ['idPanel']),
    ...mapFields('profiles', ['profiles']),
    ...mapState('authentication', ['userProfile']),
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  methods: {
    ...mapActions('panels', [
      'setPanelsInfo',
      'setCreatePanel',
      'getAllPanels',
    ]),
    ...mapActions('profiles', ['getProfiles']),

    cancel() {
      this.modalPanel = false;
    },

    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },

    async savePanel() {
      this.modalPanel = false;
      this.showSidebar = true;

      const panelsInfo = {
        title: this.title,
        description: this.description,
        perfils: this.perfils,
        defaultTemplate: true,
      };

      const dataPanel = await this.setCreatePanel({
        token: this.userAuth.token,
        panelsInfo,
      });

      this.idPanel = dataPanel._id;

      await this.getAllPanels({
        token: this.userAuth.token,
      });
    },

    openCreateCard() {
      this.$bvModal.hide('modal-create-panel');
    },

    openModalCreatePanel() {
      this.$bvModal.hide('modal-switch-option');
    },

    selectDefault() {
      this.disabledCustom = true;
      this.disabledDefault = false;

      document.getElementById('card-custom').style.background = '#f8f9fa';
      document.getElementById('card-default').style.background = '#fff';
    },

    selectCustomPainel() {
      this.disabledCustom = false;
      this.disabledDefault = true;

      document.getElementById('card-custom').style.background = '#fff';
      document.getElementById('card-default').style.background = '#f8f9fa';
    },
  },

  created() {},
};
</script>

<style scoped>
.ball-one {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}

.ball-two {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #bdbdbd;
  background-color: #bdbdbd;
}

.cards {
  align-items: center;
  justify-content: center;
  display: flex;
  padding-top: 25px;
}

.title-card {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}

.description {
  font-weight: 400;
  font-size: 12px;
  color: #242424;
}

#card-default {
  max-width: 80rem;
  width: 80rem;
  height: 30rem;
}

#card-custom {
  max-width: 80rem;
  width: 80rem;
  background-color: #f8f9fa;
  height: 30rem;
}

.card-img-top {
  padding-top: 40px;
  padding-right: 40px;
  padding-left: 40px;
}

.ball-create-panel {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}

.text-create-panel {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-top: 20px;
}

.b-sidebar-outer {
  z-index: 1040;
}

.create-card {
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
}

.card-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}

.main-sidebar {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 12px;
  background: #fff;
}

.label-text {
  margin-bottom: 0;
  margin-top: 15px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-add-template/index.vue